import React from 'react';
import { Link, Markup } from '@landing/ui';
import { Contacts } from 'components/UI';

import * as styles from './Footer.module.scss';

export default function Footer({ anchorLinks, phone, email }) {
  const currentYear = new Date().getFullYear();
  const captchaText = `This site is protected by reCAPTCHA and the <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer noopener">Google's Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer noopener">Terms of Service</a> apply.`;

  return (
    <footer className={styles.footer}>
      <div className={styles.layout}>
        <div className={styles.top}>
          <Contacts className={styles.contacts} phone={phone} email={email} />
          <div className={styles.navigation}>
            {anchorLinks?.map(({ alias, title }) => (
              <Link key={title} className={styles.link} href={alias}>
                {title}
              </Link>
            ))}
          </div>
        </div>
        <span className={styles.copyright}>{`© ${currentYear} Andersenlab.com`}</span>
        <Markup tag="span" className={styles.copyright}>
          {captchaText}
        </Markup>
      </div>
    </footer>
  );
}
